import TouchscreenView from './TouchscreenView';

export default TouchscreenView;
